import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './ElegantAbout.css';

const ElegantAbout = () => {
  const [aboutImage] = useState({
    id: 'about-desktop',
    alt: 'Bespoke Suit - Vastré By Vijh',
    sizes: {
      '480w': 'https://images.vastrebyvijh.com/vastre-images/home-about/desktop/2025-08-26/home-about_desktop_1756239593157_0_480w.webp',
      '768w': 'https://images.vastrebyvijh.com/vastre-images/home-about/desktop/2025-08-26/home-about_desktop_1756239593157_0_768w.webp',
      '1080w': 'https://images.vastrebyvijh.com/vastre-images/home-about/desktop/2025-08-26/home-about_desktop_1756239593157_0_1080w.webp',
      '1440w': 'https://images.vastrebyvijh.com/vastre-images/home-about/desktop/2025-08-26/home-about_desktop_1756239593157_0_1440w.webp',
      '1920w': 'https://images.vastrebyvijh.com/vastre-images/home-about/desktop/2025-08-26/home-about_desktop_1756239593157_0_1920w.webp',
      'fallback': '/images/home-about/home-about_desktop_1756135609955_0.webp'
    }
  });

  // Generate picture sources for responsive images
  const generatePictureSources = useCallback((imageSizes) => {
    if (!imageSizes || typeof imageSizes !== 'object') return [];
    
    const sizeOrder = ['480w', '768w', '1080w', '1440w', '1920w'];
    const sources = [];
    
    sizeOrder.forEach(size => {
      if (imageSizes[size]) {
        sources.push({
          srcset: imageSizes[size],
          media: size === '480w' ? '(max-width: 480px)' :
                 size === '768w' ? '(max-width: 768px)' :
                 size === '1080w' ? '(max-width: 1080px)' :
                 size === '1440w' ? '(max-width: 1440px)' :
                 '(min-width: 1441px)'
        });
      }
    });
    
    return sources;
  }, []);

  return (
    <section className="elegantabout-section">
      <div className="elegantabout-container">
        {/* Elegant Couture Text Section */}
        <div className="elegantabout-content-wrapper">
          <div className="elegantabout-text-section">
            <div className="elegantabout-label">
              <div className="elegantabout-label-line"></div>
              <span className="elegantabout-label-text">Timeless Craftsmanship</span>
              <div className="elegantabout-label-line"></div>
            </div>
            <h2 className="elegantabout-title">Elegant Couture</h2>
            <p className="elegantabout-description">
              Where traditional tailoring meets modern design, creating timeless pieces that define sophistication and elegance. Each stitch tells a story of dedication and artistry.
            </p>
          </div>

          {/* About Us Text Section */}
          <div className="elegantabout-text-section elegantabout-about-section">
            <h2 className="elegantabout-subtitle">Our Story</h2>
            <p className="elegantabout-story">
              Vastré By Vijh was founded with a singular vision — to revive the essence of bespoke couture. Each creation is handcrafted with precision, using the finest fabrics, and designed for the discerning individual who values sophistication and detail.
            </p>
            <Link to="/about" className="elegantabout-cta-btn">
              <span>Discover Our Story</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
        </div>

        {/* Image Section */}
        <div className="elegantabout-image-section">
          {aboutImage && aboutImage.sizes ? (
            <div className="elegantabout-img-wrapper">
              <picture>
                {generatePictureSources(aboutImage.sizes).map((source, index) => (
                  <source
                    key={index}
                    srcSet={source.srcset}
                    media={source.media}
                    type="image/webp"
                    sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 45vw"
                  />
                ))}
                <img
                  src={aboutImage.sizes?.fallback || aboutImage.sizes?.['1080w']}
                  alt={aboutImage.alt}
                  className="elegantabout-img"
                  loading="lazy"
                  sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 45vw"
                  onError={(e) => {
                    console.error('About image failed to load:', e.target.src);
                    e.target.src = '/images/fallbacks/suit.webp';
                  }}
                />
              </picture>
              
              {/* Decorative Border */}
              <div className="elegantabout-img-border"></div>
            </div>
          ) : (
            <div className="elegantabout-img-placeholder">
              <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#D6A464"/>
              </svg>
              <p>Image coming soon</p>
            </div>
          )}
        </div>
      </div>

      {/* Decorative Pattern */}
      <div className="elegantabout-pattern-overlay"></div>
    </section>
  );
};

export default ElegantAbout;

